/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { PlatformAudioComponent } from '@karya/core';
import { ParsedParams } from '@karya/generic-task-react';
import { AudioRenderer } from '@/components/TaskBuilder/Preview/common/Audio';

export function PlatformAudioRenderer({ params }: { params?: ParsedParams<any> }) {
  const typedParams = params as ParsedParams<PlatformAudioComponent>;

  return (
    <AudioRenderer
      src={typedParams?.recording}
      start={typedParams.start ?? undefined}
      end={typedParams.end ?? undefined}
    />
  );
}
